import { Component, OnInit } from "@angular/core";
import {
  NavigationEnd,
  NavigationStart,
  Router,
  Event as NavigationEvent,
} from "@angular/router";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.css"],
})
export class HeaderComponent implements OnInit {
  private router: any;

  constructor() {}

  ngOnInit(): void {

  }
}
